import React from "react";
import { useNavigate } from "react-router-dom";

function AdminUserLink({ userId, name, phone, style, subStyle }) {
  const navigate = useNavigate();

  const openProfile = () => {
    if (userId) navigate(`/admin/users/${userId}`);
  };

  return (
    <button type="button" style={{ ...buttonStyle, ...style }} onClick={openProfile} disabled={!userId}>
      <strong style={nameStyle}>{name || (userId ? `User ${userId}` : "-")}</strong>
      {phone ? <span style={{ ...phoneStyle, ...subStyle }}>{phone}</span> : null}
    </button>
  );
}

const buttonStyle = {
  display: "inline-grid",
  gap: "2px",
  padding: 0,
  border: 0,
  background: "transparent",
  color: "#0f172a",
  textAlign: "left",
  cursor: "pointer",
};

const nameStyle = {
  color: "#1d4ed8",
  fontWeight: 900,
  textDecoration: "underline",
  textDecorationColor: "rgba(37,99,235,.25)",
  textUnderlineOffset: "3px",
};

const phoneStyle = {
  color: "#64748b",
  fontSize: "12px",
  fontWeight: 700,
};

export default AdminUserLink;
